// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/login`,
      verify: `${ROOTS.AUTH}/verify`,
      register: `${ROOTS.AUTH}/register`,
      newPassword: `${ROOTS.AUTH}/new-password`,
      firstAccess: `${ROOTS.AUTH}/first-access`,
      totpCode: `${ROOTS.AUTH}/totp-code`,
      forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    auto: `${ROOTS.DASHBOARD}/auto`,
    root: `${ROOTS.DASHBOARD}/`,
    employees: `${ROOTS.DASHBOARD}/employees`,
    newEmployee: `${ROOTS.DASHBOARD}/employees/new`,
    timesheet: `${ROOTS.DASHBOARD}/timesheet`,
    requests: `${ROOTS.DASHBOARD}/requests`,
    holidayPlan: `${ROOTS.DASHBOARD}/holiday-plan`,
    calendar: `${ROOTS.DASHBOARD}/timetable`,
    connectApi: `${ROOTS.DASHBOARD}/connect-api`,
    payTransparency: `${ROOTS.DASHBOARD}/pay-transparency`,
    payTransparencyDetail: (id) => `${ROOTS.DASHBOARD}/pay-transparency/${id}`,
    documents: `${ROOTS.DASHBOARD}/documents`,
    documentSignatures: `${ROOTS.DASHBOARD}/documents/signatures`,
    letters: `${ROOTS.DASHBOARD}/letters`,
    letterDetails: (id) => `${ROOTS.DASHBOARD}/letters/${id}`,
    clockings: `${ROOTS.DASHBOARD}/clockings`,
    notices: `${ROOTS.DASHBOARD}/comunicazioni`,
    expenseReports: `${ROOTS.DASHBOARD}/note-spese`,
    helpDesk: `${ROOTS.DASHBOARD}/help-desk`,
    stats: `${ROOTS.DASHBOARD}/stats`,
    company: `${ROOTS.DASHBOARD}/company`,
    account: `${ROOTS.DASHBOARD}/account`,
    reports: `${ROOTS.DASHBOARD}/report`,
    employeesSecurityReport: `${ROOTS.DASHBOARD}/report/employee-security`,
    employeesPayrollData: `${ROOTS.DASHBOARD}/report/employee-payroll-data`,
    employeesDocuments: `${ROOTS.DASHBOARD}/report/employee-documents`,
    employeesCustomReport: `${ROOTS.DASHBOARD}/report/employee-custom`,
    timesheetCheckReport: `${ROOTS.DASHBOARD}/report/timesheet-check`,
    news: {
      root: `${ROOTS.DASHBOARD}/news`,
      details: (slug) => `${ROOTS.DASHBOARD}/news/${slug}`,
      guide: (slug) => `${ROOTS.DASHBOARD}/news/guide/${slug}`,
    },
    faq: `${ROOTS.DASHBOARD}/faq`,
    config: {
      root: `${ROOTS.DASHBOARD}/config`,
      customFields: `${ROOTS.DASHBOARD}/config/custom-fields`,
      timesheet: `${ROOTS.DASHBOARD}/config/timesheet`,
      holidayPlan: `${ROOTS.DASHBOARD}/config/holiday-plan`,
      expenseReports: `${ROOTS.DASHBOARD}/config/expense-reports`,
      projects: `${ROOTS.DASHBOARD}/config/projects`,
      clockingPlaces: `${ROOTS.DASHBOARD}/config/clocking-places`,
      supervisors: `${ROOTS.DASHBOARD}/config/supervisors`,
      orgChart: `${ROOTS.DASHBOARD}/config/org-chart`,
      documentTemplates: `${ROOTS.DASHBOARD}/config/document-templates`,
      clockingConnector: `${ROOTS.DASHBOARD}/config/connettore-timbrature`,
    },
    payrollData: `${ROOTS.DASHBOARD}/payroll-data`,
    laborCostBudget: `${ROOTS.DASHBOARD}/labor-cost-budget`,
    uploadBustePaga: `${ROOTS.DASHBOARD}/upload-buste-paga`,
  },
};
